import { useRef, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { getImageUrl } from "src/Common/common";
import { timeZoneArray } from "src/Common/contants";

// Max height of the open menu; if there's less room than this below the trigger
// (but more above it), the menu flips upward.
const DROPDOWN_MAX_HEIGHT = 240;

function TimezoneDropdown({ timezone, timezoneSelected }) {
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const [openUpward, setOpenUpward] = useState(false);
  const triggerRef = useRef(null);
  // const [selectedIndex, setSelectedIndex] = useState(0);

  const toggleDropDown = () => {
    // Decide direction before opening: flip up only when the space below isn't
    // enough but there's more room above.
    if (!isDropDownOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      setOpenUpward(spaceBelow < DROPDOWN_MAX_HEIGHT && spaceAbove > spaceBelow);
    }
    setIsDropDownOpen(!isDropDownOpen);
  };

  const timezoneClicked = (index) => {
    // setSelectedIndex(index);
    timezoneSelected(timeZoneArray[index]);
  };

  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setIsDropDownOpen(false);
      }}
    >
      <div
        ref={triggerRef}
        onClick={toggleDropDown}
        className="w-full h-[30px] px-[15px] py-[5px] border-[1px] rounded-md col-span-1 flex items-center justify-between cursor-pointer relative"
      >
        <span className="font-OpenSansRegular text-[11px] font-[400]">{timezone ? timezone : "Select Timezone"}</span>
        <img src={getImageUrl("/images/common/arrow-down.png")} />

        {isDropDownOpen && (
          <div
            className={`w-full absolute px-1 py-1 border-[#E6E7EC] border-[1px] left-0 z-10 bg-white flex flex-col justify-between shadow-xl overflow-y-auto ${
              openUpward ? "bottom-[32px]" : "top-[32px]"
            }`}
            style={{ maxHeight: `${DROPDOWN_MAX_HEIGHT}px` }}
          >
            {timeZoneArray.map((zone, index) => {
              return (
                <div
                  key={index}
                  className={`w-full h-[30px] flex items-center gap-2 px-2 relative cursor-pointer hover:bg-gray-300 ${
                    timezone === zone ? "bg-gray-300" : ""
                  }`}
                  onClick={() => timezoneClicked(index)}
                >
                  <p className="font-OpenSansRegular text-[11px] text-inputEmailTitle font-[400]">{zone}</p>
                  {index < timeZoneArray.length - 1 && (
                    <div className="w-full h-[1px] bg-gray-200 absolute left-0 right-0 bottom-0" />
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
}

export default TimezoneDropdown;
